import * as Models from 'contracts/models';

export const Endpoint = () => `/api/v3/admin/organizations_add_user/`;
export const Csrf = () => `/api/v3/admin/token/`;
export declare const QueryKey: never;
export type Payload = {
    email: string;
    role: `${Models.Organizations.OrganizationMemberRole}`;
    organizationId: string;
};
export type Response = Models.Organizations.Organization;
